<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.84)" size="default" color="#fff" type="ball-pulse"
[fullScreen]="true"> </ngx-spinner>
<section>
  <div class="wrapper">
      <div class="col-12 site-banner pl-0 pr-0">
          <div class="update-typebanner stylebanner-3">
              <div class="n_and_p_Banner-graphics">
                  <img src="assets/images/vector-smart-3.png" alt="vector-smart-3">
              </div>
              <div class="n_and_p_Banner">
                  <div class="container">
                      <!-- <div class="left-content">
                          <h1>Get <span class="sub-border">More</span> Listeners & Grow Your <span class="sub-border">Show</span></h1>
                          <p>Hayti offers a curated collection of the top Black <br>podcasters from around the world.</p>
                      </div>
                      <div class="imgRight">
                          <img src="assets/assets/images/podcasts/slide-vactor-shap.png" alt="slide-vactor-shap">
                      </div> -->
                      <div class="left-content">
                          <h1>Get <span class="sub-border">More</span> Listeners & Grow Your <span class="sub-border">Show</span></h1>
                          <p>Hayti offers a curated collection of the top Black <br>podcasters from around the world.</p>
                          <a href="javascript:void(0);" class="btn btn-green">Add Your Podcast To Hayti</a>
                      </div>
                      <div class="imgRight">
                          <img src="assets/images/slide-vactor-shap.png" alt="slide-vactor-shap">
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-12 form-section px-100">
          <div class="container">
              <!-- <div class="col-12 form-container white-card set-img-before-form">
                  <img src="assets/assets/images/podcasts/podcast-hayti-icon.png" alt="podcast-hayti-icon.png">
   
                  <div id="block-homecontactus-podcast">
                  </div>
                 
              </div> -->
              <div class="row">
                  <div class="col-12 text-center green-headtitle">
                      <h2>Popular <span>Podcasts</span></h2>
                  </div>
                  <div class="col-12 playList">
                      <div class="row">
                          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 playList-item" *ngFor="let podcast of popularPodcastList">
                              <div class="thumb-image">
                                  <img src="{{podcast?.podcast_id?.thumbnail}}" alt="{{podcast?.podcast_id?.title}}">
                              </div>
                              <div class="thumb-content">
                                  <h4>{{podcast?.podcast_id?.title}}</h4>
                                  <div class="playbtn">
                                      <a  href="javascript:void(0);" routerLink="/podcasts-web/podcast/{{podcast?.podcast_id?.alias}}"><img src="assets/images/podcasts/Popular-podcasts/playIcon.png" alt="playIcon" class="play-icon"><span>Play Now</span></a>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-12 fullbanner-section px-0">
      <div class="row">
          <div class="container">
              <div class="row">
                  <div class="col-12 banner-box">
                      <img src="assets/images/podcasts/Popular-podcasts/02-Banner.png" alt="02-Banner">
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-12 podcastCategories-section px-100">
      <div class="row">
          <div class="container">
              <div class="row">
                  <div class="col-12 text-center green-headtitle">
                      <h2>Podcast <span> categories</span></h2>
                  </div>
                  <div class="col-12 playList">
                      <div class="graphics-shape-t4">
                          <img src="assets/images/podcasts/Popular-podcasts/shape-t4.png" alt="shape-t4">
                      </div>
                      <ng-container *ngFor="let cat of podcastCategory">

                      <div class="row category-item" >
                          <div class="col-12 playList-title">
                              <h3>{{cat?.name}}</h3>
                              <div class="btn-box">
                                  <a  href="javascript:void(0);" routerLink="/podcasts-web/category/{{cat?.alias}}" class="viewall-btn">View All</a>
                              </div>
                          </div>
                          <div class="col-12 playlist-slider">
                              <div class="row">
                                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 playList-item"   *ngFor="let podcast of cat?.podcast">
                                      <div class="thumb-image">
                                          <img alt="{{podcast?.title}}" src="{{podcast?.thumbnail}}">
                                      </div>
                                      <div class="thumb-content">
                                          <h4>{{podcast?.title | titlecase}}</h4>
                                          <div class="playbtn">
                                              <a  href="javascript:void(0);" routerLink="/podcasts-web/podcast/{{podcast?.alias}}"><img src="assets/images/podcasts/Popular-podcasts/playIcon.png" alt="playIcon" class="play-icon"><span>Play Now</span></a>
                                          </div>
                                      </div>
                                  </div>
                               
                              </div>
                          </div>
                      </div>
                      </ng-container>
                     
                      <div class="graphics-shape-t5">
                          <img src="assets/images/podcasts/Popular-podcasts/shape-t5.png" alt="shape-t5">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- <div class="row">
  <div class="col-md-12">
    <h1 class="page-header">Podcasts</h1>
  </div>
</div>
<div class="thumb_sec" *ngFor="let cat of podcastCategory">
  <div class="row">
    <div class="col-md-12">
      <h3>{{cat?.name}}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2" *ngFor="let podcast of cat?.podcast" routerLink="{{podcast?.alias}}">
      <div class="thumb_wrap" title="{{podcast?.title}}">
        <div class="thumb_img"> <img src="{{podcast?.thumbnail}}"> </div>
        <div class="thumb_con">
          <h4>{{podcast?.title | titlecase}}</h4>
          <span>{{podcast?.description}}</span>
        </div>
      </div>
    </div>

  </div>
</div>  -->